import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceHeartRate', params)
  },
  showHeartRatesCareUser (params) {
    return Api().post('heartRatesPercareuser', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceHeartRateService.js